import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { MatDialogRef, MatSnackBar, MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { DesignService } from "../design.service";
import { DesignsModel, DesignSystem, SystemDesign, SystemEntity } from "../design.model";
import { MessagerComponent } from "src/app/messager/messager/messager.component";

@Component({
  selector: "app-system-design",
  templateUrl: "./system-design.component.html",
  styleUrls: ["./system-design.component.css"],
})
export class SystemDesignComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private designService: DesignService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public messager: MessagerComponent
  ) {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        this.designId = queryParams.id
        this.getViewdesignsList(this.designId);
        this.getSystemByDesign(this.designId)
      }
    });
  }

  searchSystemDesign: string | number | any | null;
  viewDesign: DesignsModel;
  systemsDesigns: SystemEntity[];
  designId:number| string;

  ngOnInit() {}

  /**
   * Get View Designs List
   */
  getViewdesignsList(SystemDesign_id) {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getViewDesigns(SystemDesign_id).subscribe(
        (result: SystemDesign) => {
          this.viewDesign = result.Designs;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

    /**
   * Get System By Design List
   */
     getSystemByDesign(SystemDesign_id) {
      this.showLoader = true;
      this.subscription$.add(
        this.designService.getSystemByDesign(SystemDesign_id).subscribe(
          (result: DesignSystem) => {
            this.systemsDesigns = result.system;
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting System Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }

    removeSystem(system): void {

      const dialogRef = this.dialog.open( RemoveDialogComponent, {
        height: '240px',
        width: '300px'
      });

      dialogRef.afterClosed().subscribe(
        (result) => {
          if (result == 1){
            console.log('closed: 1');

            //reset here

            this.designService.removeSystem(system).subscribe(
              (res) => {
                console.log(res);
                this.getSystemByDesign(this.designId);
                this.messager.openSnackBar('Successfully removed.', '', 'successAlert');
              }, err => {
                this.messager.openSnackBar('Error' + err.message, '' , 'errorAlert');
                console.log(err);
              }
            )


          }
          else {
            console.log('closed 2');
          }
        }, err => {

        }
      )

      console.log(system);
    }

    /**
   * Search For Specific System Design
   */
     searchSystemDesigns() {
      if (this.searchSystemDesign !== "") {
        this.showLoader = true;
        let searchValue = this.searchSystemDesign.toLocaleLowerCase();
        this.systemsDesigns = this.systemsDesigns.filter(
          (systemsDesign: SystemEntity) => {
            return (
              systemsDesign.name.toLocaleLowerCase().match(searchValue) ||
              systemsDesign.selection_id.toString().match(searchValue)
            );
          }
        );
        this.showLoader = false;
      } else {
        this.getSystemByDesign(this.designId);
      }
    }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}

@Component({
  template: `
    <h2 mat-dialog-title>Remove?</h2>
    <div>
      This will remove this system from this design.
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button style="background: red;color: white;" (click)="dref.close(1)" mat-dialog-close='1' >Remove</button>
      <button mat-button (click)="dref.close(2)" mat-dialog-close='2' style="margin-left: 40px;background: #ffffffaf;">Cancel</button>
    </div>
  `
})
export class RemoveDialogComponent {

  constructor(public dref: MatDialogRef<RemoveDialogComponent>){}

}
